const BASE_URL = process.env.REACT_APP_BASE_URL;

export const saveGroupAPI = async (data) => {
  const token = localStorage.getItem("token"); // get JWT token

  const params = new URLSearchParams();
  params.append("groupName", data.groupName);
  params.append("groupCoverImageUrl", data.groupCoverImageUrl);
  params.append("churchObjId", data.churchObjId);

  params.append("mobile", "false"); // optional if backend requires

  const response = await fetch(`${BASE_URL}churches/groups/save`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: params.toString(),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData?.message || "Failed to save group");
  }

  return await response.json();
};
export const saveGroupMembersAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    // Append all members data — example: memberIds array
    params.append("_id", data._id);
    // data.userAuthId?.forEach((memberId, index) =>
      params.append(`userAuthId`, data.userAuthId)
    // );
    params.append("mobile", "false");
  
    const response = await fetch(`${BASE_URL}groups/members/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save group members");
    }
  
    return await response.json();
  };
  // Save Bible Plan for a group
export const saveGroupBiblePlanAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    params.append("_id", data.groupId); // group _id
    params.append("biblePlanObjId", data.biblePlanObjId); // bible plan object ID
  
    const response = await fetch(`${BASE_URL}groups/bibleplan/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save Bible Plan");
    }
  
    return await response.json();
  };
  
  export const saveGroupDevotionalsAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    params.append("_id", data.groupId); // Group _id
    params.append("devotionalObjId", data.devotionalObjId); // Devotional Object ID
  
    const response = await fetch(`${BASE_URL}groups/devotionals/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save group devotionals");
    }
  
    return await response.json();
  };
  export const saveGroupJournalsAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    params.append("_id", data.groupId); // Group _id
    params.append("journalObjId", data.journalObjId); // Journal Object ID
  
    // Make sure the URL is correct
    const response = await fetch(`${BASE_URL}groups/journals/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save group journals");
    }
  
    return await response.json();
  };
  export const saveGroupVideosAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    params.append("_id", data.groupId); // Group _id
    params.append("videoObjId", data.videoObjId); // Video Object ID
  
    const response = await fetch(`${BASE_URL}groups/videos/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save group videos");
    }
  
    return await response.json();
  };
  
  // NEW: Save Group Curriculums API
  export const saveGroupCurriculumsAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    params.append("_id", data.groupId); // Group _id
    params.append("curriculumObjId", data.curriculumObjId); // Curriculum Object ID
  
    const response = await fetch(`${BASE_URL}groups/curriculums/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save group curriculums");
    }
  
    return await response.json();
  };
  
  // NEW: Save Group Testimonies API
  export const saveGroupTestimoniesAPI = async (data) => {
    const token = localStorage.getItem("token");
  
    const params = new URLSearchParams();
    params.append("_id", data.groupId); // Group _id
    params.append("testimonialObjId", data.testimonialObjId); // Testimonial Object ID
  
    const response = await fetch(`${BASE_URL}groups/testimonies/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to save group testimonies");
    }
  
    return await response.json();
  };
  // api.js - Add these API functions

  export const readMyGroupsAPI = async (data = {}) => {
    const token = localStorage.getItem("token");
    
    // For /mygroups endpoint, it seems to be a simple POST request
    // with no parameters based on the curl example
    const response = await fetch(`${BASE_URL}mygroups`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(data) || '{}',
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to read my groups");
    }
  
    return await response.json();
  };

  
  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/x-www-form-urlencoded",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  };
  
  const postData = async (url, data) => {
    const params = new URLSearchParams();
    for (let key in data) {
      params.append(key, data[key]);
    }
  
    const response = await fetch(`${BASE_URL}${url}`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Request failed");
    }
  
    return response.json();
  };

  export const saveDevotionalAPI = (data) => postData("devotionals/save", data);
export const saveDevotionalVideoAPI = (data) => postData("devotionals/videos/save", data);
export const saveDevotionalJournalAPI = (data) => postData("devotionals/journals/save", data);
export const saveDevotionalTestimonyAPI = (data) => postData("devotionals/testimonies/save", data);
export const saveDevotionalVerseAPI = (data) => postData("devotionals/verses/save", data);
export const readDevotionalsAPI = async (data = {}) => {
    const token = localStorage.getItem("token");
    
    const params = new URLSearchParams();
    
    // Add optional parameters only if they exist
    if (data._id) params.append("_id", data._id);
    if (data.userAuthId) params.append("userAuthId", data.userAuthId);
    if (data.churchObjId) params.append("churchObjId", data.churchObjId);
    if (data.channelObjId) params.append("channelObjId", data.channelObjId);
    if (data.ministriesObjId) params.append("ministriesObjId", data.ministriesObjId);
    if (data.devotionalTitle) params.append("devotionalTitle", data.devotionalTitle);
    
    // You can add mobile parameter if needed
    params.append("mobile", "false");
  
    const response = await fetch(`${BASE_URL}devotionals/read`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: params.toString(),
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to read devotionals");
    }
  
    return await response.json();
  };
// api.js
export const deleteGroupAPI = async (data) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("_id", data._id);

  const response = await fetch(`${BASE_URL}churches/groups/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: params.toString(),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData?.message || "Failed to delete group");
  }

  return await response.json();
};
export const updateGroupAPI = async (data) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();

  // REQUIRED
  params.append("_id", data._id);

  // OPTIONAL (append only if exists)
  if (data.userAuthId) params.append("userAuthId", data.userAuthId);
  if (data.churchObjId) params.append("churchObjId", data.churchObjId);
  if (data.channelObjId) params.append("channelObjId", data.channelObjId);
  if (data.ministriesObjId) params.append("ministriesObjId", data.ministriesObjId);
  if (data.groupName) params.append("groupName", data.groupName);

  const response = await fetch(`${BASE_URL}churches/groups/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: params.toString(),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData?.message || "Failed to update group");
  }

  return await response.json();
};

// Save YouTube Plan API
export const saveYoutubePlanAPI = async (data) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("youtubelink", data.youtubeurl); // ✅ exact key

  const response = await fetch(`${BASE_URL}youtubeplans`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded", // ✅ REQUIRED
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: params.toString(),
  });

  const text = await response.text();

  if (!response.ok) {
    throw new Error(text || "Failed to save YouTube plan");
  }

  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
};

